/*
 **********************************************************************************************
 *@license
 * Copyright (c) 2015-2025 Future Intelligence Technology Solutions Limited, United Kingdom.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 **********************************************************************************************
 */

'use strict';

export function fiContactus(evt) {
    try {
        var x = document.getElementById('fi-submit-status-id3');
        x.innerHTML = "Status : ";

        var subBut = document.getElementById('fi-btnSubmitId');
        var subButLblCore, subButLblStat;
        subButLblCore = subBut.innerHTML;
        subButLblStat = "Submitting..."
        subBut.innerHTML = subButLblStat;
        subBut.disabled = true;
        //subBut.background = "linear-gradient(45deg, rgb(246, 246, 248) 50%, rgb(255, 255, 255) 50%, rgb(248, 250, 250) 50%);";
        subBut.background = "linear-gradient(45deg, rgb(20 , 20, 200) 50%, rgb(20 , 20, 200) 50%, rgb(20 , 20, 200) 50%);";

        var subStatCon = document.getElementById('fi-submit-status-id');
        var subStat = document.getElementById('fi-submit-status-lable-id');
        subStatCon.visibility = 'visible';
        subStat.innerHTML = "Request initiated..";
        x.innerHTML = "Request initiated..";

        var geoLocationRequired = false;
        var geoLocationCaptured = false;
        var geoLocationProcessed = 0;
        var fiConApiStat = 0;

        var fiConApiURL = "https://3xrl2z3s97.execute-api.us-west-2.amazonaws.com/Beta/fi-contact-us";
        var cform = document.getElementById('fi-contact-us-form-id1');

        var c_fname = document.getElementById("fi-cf-fname-id-d");
        var c_lname = document.getElementById("fi-cf-lname-id-d");
        var c_jt = document.getElementById("fi-cf-job-title-id-d");
        var c_em = document.getElementById("fi-cf-email-id-d");
        var c_ph = document.getElementById("fi-cf-phone-id-d");
        var c_cname = document.getElementById("fi-cf-company-name-id-d");
        var c_curl = document.getElementById("fi-cf-company-url-id-d");
        var c_loc = document.getElementById("fi-cf-company-location-id-d");
        var c_msg = document.getElementById("fi-cf-msg-id-d");
        var c_locper = document.getElementById("fi-cf-loc-acpt-cb-id-d");
        var c_tacpt = document.getElementById("fi-cf-acpt-cb-id-d");
        var navigator_status = "";


        var c_navigatorData = {
            "latitude": "",
            "longitude": "",
            "appCodeName": "",
            "appName": "",
            "appVersion": "",
            "cookieEnabled": "",
            "onLine": "",
            "language": "",
            "platform": "",
            "userAgent": ""
        };
        var c_data = {
            "custfname": "",
            "custlname": "",
            "custjobtitle": "",
            "custemail": "",
            "custphone": "",
            "custcompname": "",
            "custcompurl": "",
            "custlocation": "",
            "custmsg": "",
            "custlocpermission": "",
            "custtcaccetpance": "",
            "custnavigatorstatus": "",
            "custnavigator": c_navigatorData,
        }; // end of c_data definition


        if ((fiIsDataValid()) == true) {
            //x.innerHTML = x.innerHTML + " : " + "data validated";
            //x.innerHTML = x.innerHTML + " : " + "c_fname : " + c_fname.value;
            //x.innerHTML = x.innerHTML + " : " + " fi-cf-fname-id-d : " + document.getElementById("fi-cf-fname-id-d").value;
            c_data = {
                "custfname": c_fname.value,
                "custlname": c_lname.value,
                "custjobtitle": c_jt.value,
                "custemail": c_em.value,
                "custphone": c_ph.value,
                "custcompname": c_cname.value,
                "custcompurl": c_curl.value,
                "custlocation": c_loc.value,
                "custmsg": c_msg.value,
                "custlocpermission": c_locper.checked,
                "custtcaccetpance": c_tacpt.checked,
                "custnavigatorstatus": navigator_status,
                "custnavigator": c_navigatorData,
            }; // end of c_data definition

            //    var xy = JSON.stringify(c_navigatorData);
            //    x.innerHTML = x.innerHTML + " navigator data : " + xy;
            //    xy = JSON.stringify(c_data);
            //    x.innerHTML = x.innerHTML + " c data : " + xy;
            navigator_status = c_locper.checked;

            if (c_locper.checked == true) {
                geoLocationRequired = true;
                geoLocationCaptured = false;
                c_data.custnavigatorstatus = navigator_status;
                //c_data.custnavigator = fiGetLocationData();
                c_navigatorData = {
                    "latitude": "",
                    "longitude": "",
                    "appCodeName": navigator.appCodeName,
                    "appName": navigator.appName,
                    "appVersion": navigator.appVersion,
                    "cookieEnabled": navigator.cookieEnabled,
                    "onLine": navigator.onLine,
                    "language": navigator.language,
                    "platform": navigator.platform,
                    "userAgent": navigator.userAgent,
                }
                c_data.custnavigator = c_navigatorData;
                geoLocationProcessed = 1;
                fiGetLocationData();

                function waitForGeoLocation() {
                    if (geoLocationProcessed == 1) {
                        subStat.innerHTML = "Wait for Geo Location!";
                        x.innerHTML = x.innerHTML + "<br> Wait for Geo Location!";
                        setTimeout(function () {
                            waitForGeoLocation()
                        }, 5000);
                    } else {
                        // go do that thing
                    }
                }
                waitForGeoLocation();
                //c_data.custnavigatorstatus = navigator_status;
            } // no else for this one

            if (geoLocationRequired) {
                //alert ("hello");
                var waitTimeSec = 5;
                var i = 1;
                while (i <= waitTimeSec) {
                    //alert ("hello");
                    if (geoLocationCaptured && i > 3) {
                        subStat.innerHTML = "Geo Location captured.";
                        break;
                    }

                    if (!geoLocationCaptured) {
                        subStat.innerHTML = "Waiting for Geo Location: " + i + "seconds";
                        sleep(1000);
                        console.log("Waited for Geo Location: " + i + "seconds");
                    }
                    i = i + 1;
                }
            }

            var xy = JSON.stringify(c_navigatorData);
            x.innerHTML = x.innerHTML + "<br> ---- navigator data : " + xy;

            xy = JSON.stringify(c_data);
            x.innerHTML = x.innerHTML + "<br> ---- c data : " + xy;

            fiContactusAPI();
            //fiConApiStat = 1;       
            function waitForFiConApi() {
                if (fiConApiStat != 3) {
                    subStat.innerHTML = "Wait for Contact us API!";
                    x.innerHTML = x.innerHTML + "<br> Wait for Contact us API!";
                    setTimeout(function () {
                        waitForFiConApi()
                    }, 5000);
                } else {
                    // go do that thing
                }
            }

            waitForFiConApi();

            if (fiConApiStat != 3) {
                //alert ("hello");
                var waitTimeSec = 3;
                var i = 1;
                while (i <= waitTimeSec) {
                    //alert ("hello");
                    if (fiConApiStat == 3) {
                        subStat.innerHTML = "Message Sent Sucesessfully!";
                        break;
                    }

                    if (fiConApiStat != 3) {
                        subStat.innerHTML = "Waiting for Contact us API .." + i + "seconds";
                        sleep(1000);
                        console.log("Waited for Contact us API .." + i + "seconds");
                    }
                    i = i + 1;
                }
            }

            subBut.innerHTML = subButLblCore;
            subBut.disabled = false;
            subBut.background = "linear-gradient(45deg, rgb(246, 246, 248) 50%, rgb(255, 255, 255) 50%, rgb(248, 250, 250) 50%);";
            subStat.innerHTML = "Submitted Successfully!";
            x.innerHTML = "Submitted Successfully!";
        } else {

            x.innerHTML = x.innerHTML + " : " + "Data not validated!";
            subStat.innerHTML = subStat.innerHTML + " : Data not validated!";
            subBut.innerHTML = subButLblCore;
            subBut.disabled = false;
            subBut.background = "linear-gradient(45deg, rgb(246, 246, 248) 50%, rgb(255, 255, 255) 50%, rgb(248, 250, 250) 50%);";
        }

        function fiIsDataValid() {
            var isValidFname = (c_fname.value == "") ? false : true;
            var isValidLname = (c_lname.value == "") ? false : true;
            var isValidEmail = (c_em.value == "") ? false : true;
            var isValidMessage = (c_msg.value == "") ? false : true;
            var isAccetance = (c_tacpt.checked == false) ? false : true;
            //subStat.innerHTML = "Validating Data..";
            //isValidFname = document

            //x.innerHTML = x.innerHTML + " : " + "isValidFname : "+ isValidFname;
            //x.innerHTML = x.innerHTML + " : " + "c_data.c_fname : "+ c_data.c_fname;
            //x.innerHTML = x.innerHTML + " : " + "c_fname : "+ c_fname;
            //x.innerHTML = x.innerHTML + " : " + "c_fname.value : "+ c_fname.value;

            if (isValidFname && isValidLname && isValidEmail && isValidMessage && isAccetance) {
                return true;
            } else {
                x.innerHTML = x.innerHTML + [(isValidFname == false) ? ': First name is required!' : ''];
                x.innerHTML = x.innerHTML + [(isValidLname == false) ? ': Last name is required!' : ''];
                x.innerHTML = x.innerHTML + [(isValidEmail == false) ? ': Email is required!' : ''];
                x.innerHTML = x.innerHTML + [(isValidMessage == false) ? ': Message is required!' : ''];
                x.innerHTML = x.innerHTML + [(isAccetance == false) ? ': Acceptance is required!' : ''];
                subStat.innerHTML = "Required Data is missing! ";
                return false;
            }
        }

        function fiContactusAPI() {
            fiConApiStat = 1;
            var xhttpObj = new XMLHttpRequest();
            var api_data = {
                "name": "",
                "phone": "",
                "email": "",
                "desc": "",
                "first_name": "",
                "last_name": "",
                "customer_message": "",
                "job_title": "",
                "company_name": "",
                "company_website": "",
                "customer_location": "",
                "terms_accepted": "",
                "location_data_access_allowed": "",
                "location_data_status": "",
                "location_data": ""
            };

            api_data.name = c_data.custfname + " " + c_data.custlname;
            api_data.phone = c_data.custphone;
            api_data.email = c_data.custemail;
            api_data.desc = c_data.custmsg;
            api_data.first_name = c_data.custfname;
            api_data.last_name = c_data.custlname;
            api_data.customer_message = c_data.custmsg;
            api_data.job_title = c_data.custjobtitle;
            api_data.company_name = c_data.custcompname;
            api_data.company_website = c_data.custcompurl;
            api_data.customer_location = c_data.custlocation;
            api_data.terms_accepted = c_data.custtcaccetpance;
            api_data.location_data_access_allowed = c_data.custlocpermission;
            api_data.location_data_status = c_data.custnavigatorstatus;
            api_data.location_data = JSON.stringify(c_navigatorData);

            console.log("apid data string: " + JSON.stringify(api_data));
            console.log("c_data string: " + JSON.stringify(c_data));
            console.log("c_navigatordata string: " + JSON.stringify(c_navigatorData));

            xhttpObj.open("POST", fiConApiURL, true);
            xhttpObj.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            xhttpObj.send(JSON.stringify(api_data));

            xhttpObj.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    fiConApiStat = 3;
                    //x.innerHTML = x.innerHTML + " Submitted !";
                    x.innerHTML = "Message Sent Sucesessfully!";
                    //subStat.innerHTML = "Message Sent Sucesessfully!" ;

                    cform.reset();
                } else {
                    fiConApiStat = 2;
                    x.innerHTML = x.innerHTML + " Error in Contact US API (xhttp) - this.readyStates:" + this.readyState + " this.status:" + this.status == 200 + " responsetext: " + xhttpObj.responseText;
                }
            };

        } //end of fiContactusAPI

        function fiGetLocationData() {
            var startPos, startPosLat, startPosLon;
            var geoOptions = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            };
            subStat.innerHTML = "Capturing Location Data...";

            var geoSuccess1 = function (position) {
                startPos = position;
                startPosLat = position.coords.latitude;
                startPosLon = position.coords.longitude;
                //document.getElementById('startLat').innerHTML = startPos.coords.latitude;
                //document.getElementById('startLon').innerHTML = startPos.coords.longitude;
                x.innerHTML = x.innerHTML + " : " + 'Geo Location Captured Succesfully!';
                c_navigatorData.latitude = startPosLat;
                c_navigatorData.longitude = startPosLon;
                //navigator_status = navigator_status + " : lat " + startPos.coords.latitude;
                //navigator_status = navigator_status + " : lon " + startPos.coords.longitude;
                x.innerHTML = x.innerHTML + " : lat " + c_navigatorData.latitude;
                x.innerHTML = x.innerHTML + " : lon " + c_navigatorData.longitude;
                x.innerHTML = x.innerHTML + " : lat " + startPosLat;
                x.innerHTML = x.innerHTML + " : lon " + startPosLon;
                //navigator.geolocation.getCurrentPosition(geoSuccess1, geoError1);
                //navigator_status = navigator_status + " : startPos... " + startPos ;
                c_navigatorData.latitude = startPosLat;
                c_navigatorData.longitude = startPosLon;

                c_data.custnavigator = c_navigatorData;

                navigator_status = navigator_status + " : captured!!! ";
                c_data.custnavigatorstatus = navigator_status;
                x.innerHTML = x.innerHTML + " : captured!!! ";
                var xyz = JSON.stringify(c_data);
                x.innerHTML = x.innerHTML + "<br> --<last> c data : " + xyz;

                subStat.innerHTML = "Location Data Captured...";
                geoLocationCaptured = true;
                geoLocationProcessed = 2;
                //return position;
            }; // end of geoSuccess

            var geoError1 = function (error) {
                navigator_status = navigator_status + " : " + 'Error occurred. Error code: ' + error.code;
                x.innerHTML = x.innerHTML + " : " + 'Error occurred. Error code: ' + error.code;
                console.log('Error occurred. Error code: ' + error.code);
                // error.code can be:
                //   0: unknown error
                //   1: permission denied
                //   2: position unavailable (error response from location provider)
                //   3: timed out
                //var x = document.getElementById('geoLocMsg');
                subStat.innerHTML = "Not able to capture Location Data...";
                geoLocationProcessed = 3;
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        navigator_status = navigator_status + " : " + "User denied the request for Geolocation."
                        break;
                    case error.POSITION_UNAVAILABLE:
                        navigator_status = navigator_status + " : " + "Location information is unavailable."
                        break;
                    case error.TIMEOUT:
                        navigator_status = navigator_status + " : " + "The request to get user location timed out."
                        break;
                    case error.UNKNOWN_ERROR:
                        navigator_status = navigator_status + " : " + "An unknown error occurred."
                        break;
                }
            }; // end of geoError1

            if (navigator.geolocation) {
                navigator_status = navigator_status + " : " + 'Navigator Geolocation is supported!';
                x.innerHTML = x.innerHTML + " : " + 'Navigator Geolocation is supported!';

                console.log('Geolocation is supported!');

                x.innerHTML = x.innerHTML + " : capturing... ";

                navigator.geolocation.getCurrentPosition(geoSuccess1, geoError1, geoOptions);

            } else {
                navigator_status = navigator_status + " : " + 'Geolocation is not supported for this Browser/OS.';
                x.innerHTML = x.innerHTML + " : " + 'Geolocation is not supported for this Browser/OS.';
                console.log('Geolocation is not supported for this Browser/OS.');
            }
        } // end of getLocationData

    } // end of try
    catch (err) {
        subBut.innerHTML = subButLblCore;
        subBut.disabled = false;
        subBut.background = "linear-gradient(45deg, rgb(246, 246, 248) 50%, rgb(255, 255, 255) 50%, rgb(248, 250, 250) 50%);";
        subStat.innerHTML = "Error : Not Submitted..." + err.message;
        console.log(err.message);
    }
} // end of fiContactus(evt)

function sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
        if ((new Date().getTime() - start) > milliseconds) {
            break;
        }
    }
}


//module.exports = fiContactus;